module.exports = __webpack_public_path__ + "static/media/acorn.8d54a7d4.png";